import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { router } from '@/routes';
import { SiteConfigProvider } from '@/context/SiteConfigContext';
import '@/theme.css';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <HelmetProvider>
      <SiteConfigProvider>
        <RouterProvider router={router} />
      </SiteConfigProvider>
    </HelmetProvider>
  </React.StrictMode>
);
